import { __awaiter } from "tslib";
/**
 * 发起争议处理
 */
import { createStore } from '@souche-f2e/muji';
import { notification } from 'antd';
import Api from '@/services';
import { dispatch } from '@@/store';
import { getNameByCode } from '@/shared/functions';
import Luban from '@souche-f2e/luban-js';
// import { consoleSandbox } from '@sentry/utils';
export default createStore({
    state: {
        callback: null,
        id: '',
        actionType: '',
        transId: '',
        orderTag: '',
        confirmLoading: false,
        visible: false,
        visibles: false,
        openVal: '',
        openType: [],
        disputeType: [],
        disputeChildType: [],
        currentSelOpenType: '',
        currentSelDisputeType: '',
        currentSelDisputeChildType: '',
        /**
         * 0: 等待签署合同 'PSGJB-ORDER-DQSHT-ZYFQ'
         * 1: 待付款车辆   'PSGJB-ORDER-DFKCC-ZYCL'
         * 2: 等待过户车辆 'PSGJB-ORDER-DGHCC-ZYFQ'
         */
        lubanList: ['PSGJB-ORDER-DQSHT-ZYFQ', 'PSGJB-ORDER-DFKCC-ZYCL', 'PSGJB-ORDER-DGHCC-ZYFQ'],
        lubanType: null,
    },
    effects: {
        // 更改争议发起方
        changeOpenType(payload, { state }) {
            this.getDisputeType(payload);
            this.SET_STATE({ currentSelOpenType: payload });
        },
        // 更改争议类型
        changeDisputeType(payload, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.SET_STATE({ currentSelDisputeType: payload });
            });
        },
        // 更改争议子类型
        changeDisputeChildType(payload, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.SET_STATE({ currentSelDisputeChildType: payload });
            });
        },
        // 获取发起方
        getOpenType() {
            Api.order.getOpenType().then((data) => {
                this.SET_STATE({ openType: data });
            });
        },
        // 获取争议类型
        getDisputeType(payload) {
            Api.order.getDisputeType({ sourceCode: payload }).then((data) => {
                this.SET_STATE({ disputeType: data });
            });
        },
        // 获取争议子类型
        getDisputeChildType(payload, { state }) {
            const params = {
                sourceCode: state.currentSelOpenType,
                typeCode: state.currentSelDisputeType,
            };
            Api.order.getDisputeChildType(params).then((data) => {
                this.SET_STATE({ disputeChildType: data });
            });
        },
        // 跳转到争议子类型设置
        goDisputeChildType(payload) {
            this.hide();
            dispatch.router.push('/system/argueRules');
        },
        // 提交
        confirmDispute(form, { state }) {
            const { transData } = state;
            form.validateFields((error, values) => {
                if (!error) {
                    const params = {
                        orderId: transData.orderId,
                        disputeBy: getNameByCode(state.openType, state.currentSelOpenType, 'code', 'name'),
                        disputeTypeName: getNameByCode(state.disputeType, state.currentSelDisputeType, 'code', 'name'),
                        disputeSubtype: getNameByCode(state.disputeChildType, state.currentSelDisputeChildType, 'id', 'childTypeName') || '',
                        disputeReason: values.disputeReason,
                        orderStatus: transData.orderStatus,
                        recStatus: transData.recStatus,
                    };
                    Api.order.submitDisputeApply(params).then((data) => {
                        if (data) {
                            this.hide();
                            Luban.send({
                                typeId: state.lubanList[state.lubanType],
                                eventType: 'click',
                            });
                            notification.success({ message: '发起争议成功' });
                            this.resetState();
                        }
                        else {
                            notification.error({ message: '发起争议失败,请稍后重试' });
                        }
                        state.callback && state.callback(state.id);
                    });
                }
            });
        },
        // 确认发起争议处理
        confirmDisputeDeal(form, { state }) {
            const { orderId, recStatus, orderStatus, } = state.transData;
            form.validateFields((error, values) => {
                if (!error) {
                    const params = {
                        orderId,
                        recStatus,
                        orderStatus,
                        breachPrice: '2000',
                        disputeResult: 1,
                        disputeRemark: values.disputeReason,
                    };
                    Api.order.getDealPayTransfer(params).then((data) => {
                        if (data) {
                            this.hide();
                            notification.success({ message: '发起争议成功' });
                        }
                        else {
                            notification.error({ message: '发起争议失败,请稍后重试' });
                        }
                        state.callback && state.callback(state.id);
                    });
                }
            });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload).forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        show(state, { data, lubanType, callback }) {
            if (data) {
                state.transData = data;
                state.callback = callback;
                state.lubanType = lubanType;
                state.visible = true;
            }
            else {
                console.warn('发起争议组件必需参数id,请检查是否传入！');
            }
        },
        showTrans(state, { data, callback }) {
            state.transData = data;
            state.callback = callback;
            state.visibles = true;
        },
        passData(state, { actionType, orderTag }) {
            state.actionType = actionType;
            state.orderTag = orderTag;
        },
        hide(state) {
            state.visible = false;
            state.id = null;
            state.callback = null;
            state.lubanType = null;
            state.visibles = false;
        },
        resetState(state) {
            state.openVal = '';
            state.disputeType = [];
            state.actionType = '';
            state.orderTag = '';
        },
    },
});
